import NumberFormatInput from './NumberFormatInput'

export default NumberFormatInput
